<template>
  <div class="callme_total_wrap">
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <!-- 左侧：订阅+社交 + 新增Logo -->
        <div class="footer-left">
          <!-- Logo 区域 -->
          <div class="footer-logo">
            <img v-if="logoUrl" :src="logoUrl" alt="logo" />
          </div>

          <div class="subscribe-tit">Join our network</div>
          <p class="subscribe-desc">Be the first to get our latest styles and offers.</p>
          <div class="subscribe-form">
            <input type="text" v-model="email" @keyup.enter="handleSubscribe" placeholder="Email Address" />
            <button class="send-btn">
              <i class="send-icon" @click="handleSubscribe">➤</i>
            </button>
          </div>
          <p class="error-tip" v-if="errorMsg">{{ errorMsg }}</p>
          <div class="social-group">
            <a :href="globalDicts['facebook']" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/facebook.png" alt="facebook" title="Facebook"/>
            </a>
            <a :href="globalDicts['insAddress']" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/instagram.png" alt="instagram" title="Instagram"/>
            </a>
            <a :href="globalDicts['youTobe']" target="_blank" rel="noopener noreferrer">
              <img src="@/assets/youtube.png" alt="youtube" title="YouTube"/>
            </a>
          </div>
        </div>

        <!-- 右侧菜单区域 -->
        <div class="footer-right">
          <!-- Products 双列 -->
          <div class="items_wrap" v-if="menuList[1]?.children?.length > 0">
            <div class="item_tit">{{ menuList[1]?.menuName }}</div>
            <div class="item-options-row">
              <span @click="handleToRouter(item.routePath)" v-for="item in menuList[1]?.children" :key="item.id">
                {{ item.menuName }}
              </span>
            </div>
          </div>

          <!-- About Us 单列 -->
          <div class="items_wrap" v-if="menuList[3]?.children?.length > 0">
            <div class="item_tit">{{ menuList[3]?.menuName }}</div>
            <div class="item-options-col">
              <span @click="handleToRouter(item.routePath)" v-for="item in menuList[3]?.children" :key="item.id">
                {{ item.menuName }}
              </span>
            </div>
          </div>

          <!-- Follow us 单列 -->
          <div class="items_wrap">
            <div class="item_tit">Follow us</div>
            <div class="item-options-col">
              <img :src="globalDicts['follow']" alt="" />
            </div>
          </div>

          <!-- Contact Us 单列（新增图标） -->
          <div class="items_wrap">
            <div class="item_tit">Contact Us</div>
            <div class="item-options-col">
              <div class="massage_show">
                <p @click="openTel"><img class="icon-img" src="@/assets/tel.png"> {{ globalDicts['contact'] }}</p>
                <p @click="openWhatsapp"><img class="icon-img" src="@/assets/whatsapp.png"> {{ globalDicts['whatsapp'] }}</p>
                <p @click="openEmail"><img class="icon-img" src="@/assets/email.png"> {{ globalDicts['email'] }}</p>
                <p @click="openAddress"><img class="icon-img" src="@/assets/location.png"> {{ globalDicts['address']
                  }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 友情链接 + 备案号 -->
      <div class="navigate_wrap" v-if="linkList.length !== 0">
        <span>Friendship links:</span>
        <a :href="link.url" v-for="link in linkList" :key="link.id">{{ link.linkName }}</a>
        <span v-html="globalDicts['icp']" style="white-space: pre-line;"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { treeselect } from '../../api/menu';
import {getAllLinks, getJoinOurNetwork, leftLikeDict} from '../../api/system';

export default {
  data() {
    return {
      activeIndex: '1',
      menuList: [{}, {}, {}, {}],
      linkList: [],
      logoUrl: "", // 存储logo图片地址
      email: "",
      errorMsg: ""
    }
  },
  computed: {
    globalDicts() {
      return this.$store.getters.getDicts;
    },
  },
  methods: {
    handleToRouter(url) {
      this.$router.replace(url)
    },
    async treeselectFunc() {
      const res = await treeselect()
      if (res.data) {
        this.menuList = res.data.data
      }
    },
    async getAllLinksFunc() {
      const res = await getAllLinks()
      if (res.data) {
        this.linkList = res.data.data
      }
    },
    async getLogo() {
      const res = await leftLikeDict("logo")
      // 接口正常、数组有数据，取第一条 dictValue
      if (res.data.code === 200) {
        this.logoUrl = res.data.data[0].dictValue
      }
    },
    async handleSubscribe() {
      this.errorMsg = "";
      const msg = this.validateEmail(this.email);
      if (msg) {
        this.errorMsg = msg;
        return;
      }
      try {
        await getJoinOurNetwork(this.email)
        this.$message.success('Submitted successfully')
      } catch (err) {
        this.$message.error('Submission failed, please try again')
      }
      this.email = "";
    },
    validateEmail(email) {
      if (!email) {
        return "Please enter your email address";
      }
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!reg.test(email)) {
        return "Please enter a valid email address";
      }
      return "";
    },
    openWhatsapp() {
      const phone = this.globalDicts['whatsapp']
      // 去除空格、+号以外符号，只保留数字
      const cleanPhone = phone.replace(/\s/g, '').replace(/[^\d+]/g, '')
      if (!cleanPhone) return
      window.open(`https://wa.me/${cleanPhone}`)
    },
    openEmail() {
      const mail = this.globalDicts['email']
      if (!mail) return
      // mailto 协议会自动唤起系统默认邮件客户端
      window.open(`mailto:${mail}`)
    },
    openTel() {
      let telNum = this.globalDicts['contact']
      // 清除所有空格，只保留数字和+号
      const cleanTel = telNum.replace(/\s+/g, "");
      if (!cleanTel) return;
      // tel: 协议唤起系统拨号界面
      window.open(`tel:${cleanTel}`);
    },
    openAddress() {
      const address = this.globalDicts['address']
      if (!address) return;
      // 地址转URL编码，避免空格、特殊符号报错
      const encodeAddr = encodeURIComponent(address);
      // Google地图搜索地址链接
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodeAddr}`);
    }
  },
  mounted() {
    this.treeselectFunc()
    this.getAllLinksFunc()
    this.getLogo()
  }
}
</script>

<style lang="scss" scoped>
.social-group {
  display: flex;
  gap: 18px;

  a {
    text-decoration: none;
  }

  img {
    width: 42px;
    height: 42px;
    cursor: pointer;
  }
}
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;

  .callme_bottom_wrap {
    width: 100%;
    background: linear-gradient(135deg, #6ecbc8 0%, #880f53 100%);
    color: #fff;
    padding: 70px 0 30px;

    .bottom_container {
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-bottom: 60px;
      border-bottom: solid rgba(255, 255, 255, 0.2) 1px;
      flex-wrap: wrap;

      .footer-left {
        width: 24%;
        min-width: 220px;
        display: flex;
        flex-direction: column;

        /* Logo 样式 */
        .footer-logo {
          margin-bottom: 30px;
          img {
            max-width: 180px;
            height: auto;
            display: block;
          }
        }

        .subscribe-tit {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 12px;
          font-family: 'Roboto_Bold', sans-serif;
        }

        .subscribe-desc {
          font-size: 22px;
          color: #ffffff;
          line-height: 1.6;
          margin: 0 0 25px;
          font-family: 'Roboto', sans-serif;
        }

        .subscribe-form {
          display: flex;
          height: 48px;
          background: #000;
          border-radius: 24px;
          overflow: hidden;
          margin-bottom: 30px;
          font-family: 'Roboto', sans-serif;

          input {
            flex: 1;
            background: transparent;
            border: none;
            outline: none;
            color: #fff;
            padding: 0 20px;
            font-size: 17px;

            &::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }
          }

          .send-btn {
            width: 48px;
            height: 48px;
            background: #880f53;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            .send-icon {
              color: #fff;
              font-size: 20px;
            }
          }
        }

        .social-group {
          display: flex;
          gap: 18px;

          img {
            width: 42px;
            height: 42px;
            cursor: pointer;
          }
        }
      }

      .footer-right {
        width: 70%;
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        min-width: 300px;
      }

      .items_wrap {
        min-width: 160px;
        box-sizing: border-box;
        flex: 1;

        .item_tit {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 24px;
          font-family: 'Roboto_Bold', sans-serif;
        }

        .item-options-col {
          display: flex;
          flex-direction: column;
          gap: 18px;
          font-family: 'Roboto', sans-serif;

          span {
            color: #ffffff;
            font-size: 20px;
            cursor: pointer;
            transition: all 0.2s ease;
            text-decoration: none;

            &:hover {
              color: #16f6ef;
              text-decoration: underline;
            }
          }

          .massage_show {
            p {
              display: flex;
              align-items: center;
              margin: 8px 0;
              padding: 4px 0;
              font-size: 20px;
              line-height: 1;
              color: #fff;
              cursor: pointer;

              &:hover {
                color: #16f6ef;
                text-decoration: underline;
              }
            }
            .icon-img {
              width: 25px;
              height: 25px;
              margin-right: 10px;
              flex-shrink: 0;
              object-fit: contain;
              transform: translateY(-2px);
            }
          }

          img {
            width: 100%;
            max-width: 120px;
            margin-top: 8px;
          }
        }

        .item-options-row {
          display: flex;
          flex-wrap: wrap;
          gap: 18px 32px;
          font-family: 'Roboto', sans-serif;

          span {
            flex: 0 0 calc(50% - 16px);
            color: #ffffff;
            font-size: 20px;
            cursor: pointer;
            transition: all 0.2s ease;
            text-decoration: none;

            &:hover {
              color: #16f6ef;
              text-decoration: underline;
            }
          }
        }
      }

      /* Contact Us 通栏 */
      .items_wrap:nth-child(4) {
        flex: 1 1 100%;
      }
    }

    .navigate_wrap {
      width: 80%;
      margin: 25px auto 0;
      padding-bottom: 15px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px;

      span {
        font-size: 20px;
        color: #fff;
      }

      a {
        color: rgba(255, 255, 255, 0.7);
        font-size: 20px;
        text-decoration: none;

        &:hover {
          color: #fff;
        }
      }
    }
  }
}

/* 小屏：左右变成上下 */
@media (max-width: 960px) {
  .callme_total_wrap .callme_bottom_wrap .bottom_container {
    flex-direction: column;
  }
  .callme_total_wrap .callme_bottom_wrap .bottom_container .footer-left,
  .callme_total_wrap .callme_bottom_wrap .bottom_container .footer-right {
    width: 100%;
  }
  /* 小屏logo自适应 */
  .footer-left .footer-logo img {
    max-width: 150px;
  }
}

/* 移动端全局适配 768px 及以下，PC 完全不变 */
@media (max-width: 768px) {
  .callme_total_wrap {
    margin-top: 40px;

    .callme_bottom_wrap {
      padding: 35px 0 20px;

      .bottom_container {
        width: 96%;
        padding-bottom: 30px;

        /* 左侧整区适配 */
        .footer-left {
          width: 100%;
          min-width: unset;

          .footer-logo {
            margin-bottom: 20px;
            img {
              max-width: 130px;
            }
          }

          .subscribe-tit {
            font-size: 22px;
            margin-bottom: 8px;
          }

          .subscribe-desc {
            font-size: 17px;
            margin: 0 0 20px;
          }

          .subscribe-form {
            height: 42px;
            margin-bottom: 20px;
            input {
              font-size: 16px;
            }
            .send-btn {
              width: 42px;
              height: 42px;
              .send-icon {
                font-size: 18px;
              }
            }
          }

          .social-group {
            gap: 15px;
            img {
              width: 36px;
              height: 36px;
            }
          }
        }

        /* 右侧菜单布局重构 */
        .footer-right {
          width: 100%;
          gap: 16px;
          min-width: unset;
          margin-top: 10px;

          .items_wrap {
            min-width: unset;

            /* Products 整行，内部强制一行两个 */
            &:nth-child(1) {
              flex: 1 1 100%;
              .item-options-row {
                display: flex;
                flex-wrap: wrap;
                gap: 12px 16px;
                span {
                  flex: 1 1 calc(50% - 8px);
                  box-sizing: border-box;
                  font-size: 17px;
                }
              }
            }

            /* About / Follow 各占一半，并排 */
            &:nth-child(2),
            &:nth-child(3) {
              flex: 1 1 calc(50% - 8px);
            }

            /* Contact 保持通栏 */
            &:nth-child(4) {
              flex: 1 1 100%;
            }

            .item_tit {
              font-size: 20px;
              margin-bottom: 14px;
            }

            .item-options-col {
              gap: 12px;
              span {
                font-size: 17px;
              }
              img {
                max-width: 100px;
              }
            }
          }
        }
      }

      /* 底部友情链接 + 备案 */
      .navigate_wrap {
        width: 96%;
        margin: 20px auto 0;
        gap: 8px;
        span, a {
          font-size: 16px;
        }
      }
    }
  }
}

.error-tip {
  margin: 1px 0 50px; // 上边距极小，紧贴输入框
  color: #c30506;
  font-size: 18px;
  padding-left: 20px; // 和输入框文字左对齐
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 15px;
  }
}

/* 联系方式图标 - 移动端独立样式 */
@media (max-width: 768px) {
  .massage_show p {
    font-size: 17px !important;
    margin: 8px 0 !important;
  }
  .massage_show .icon-img {
    width: 18px !important;
    height: 18px !important;
    margin-right: 5px !important;
    transform: translateY(-1px) !important;
  }
}
</style>